import { ColumnDef } from "@tanstack/react-table";
import { Path } from "@/router";
import { actionId, type TableRowMenu } from "@/hooks/useTableRowMenu";
import { buildActionColumn } from "@/components/Table";
import { ActivityTypeTableRow } from "./types";
import { renderSectionAvailability } from "./_utils";

export interface TableColumnsOptions {
  navigate: (path: Path) => void;
  setMenu: (menu: TableRowMenu) => void;
}

export function getColumns({ navigate, setMenu }: TableColumnsOptions): ColumnDef<ActivityTypeTableRow, unknown>[] {
  return [
    {
      accessorKey: "activityType",
      header: "Activity Type",
      cell: ({ row }) => (
        <div>
          <div>{row.original.activityType}</div>
          <div className="text-body-small text-sys-brand-on-surface-variant">
            <div>{row.original.activityCode}</div>
          </div>
        </div>
      ),
      size: 250,
      enableSorting: false,
      meta: { headerClassName: "hide-header-in-column" }
    },
    {
      accessorKey: "description",
      header: "Description",
      cell: ({ row }: { row: { original: ActivityTypeTableRow } }) => row.original.description,
      size: 300,
      enableSorting: false,
      meta: { headerClassName: "hide-header-in-column" }
    },
    {
      accessorKey: "creditRate",
      header: "PDR Credit Rate",
      cell: ({ row }: { row: { original: ActivityTypeTableRow } }) => row.original.creditRate,
      size: 120,
      enableSorting: false
    },
    {
      accessorKey: "publishedActivities",
      header: "Published Activities",
      cell: ({ row }: { row: { original: ActivityTypeTableRow } }) => row.original.publishedActivities ?? "--",
      size: 120,
      enableSorting: false
    },
    {
      accessorKey: "sectionAvailability",
      header: "Section",
      cell: ({ row }: { row: { original: ActivityTypeTableRow } }) =>
        renderSectionAvailability(row.original.sectionAvailability),
      size: 120,
      enableSorting: false
    },
    buildActionColumn<ActivityTypeTableRow>({
      getActions: (row) => [
        {
          text: "View Activities",
          onClick: () => navigate(`/activities/activity-types/${row.id}` as Path)
        },
        {
          text: "View Participants",
          onClick: () => navigate(`/activities/activity-types/${row.id}/participants` as Path)
        }
      ],
      actionId,
      setMenu
    })
  ];
}
